import React from 'react';
import { Screen } from '../enums/screen.enum';
import { Trans, useTranslation } from 'react-i18next';
import { Button, ButtonGroup, ButtonVariant } from '../components/Button';
import ActionsContainer from '../partials/ActionsContainer';
import ContentContainer from '../partials/ContentContainer';
import ScreenContainer from '../partials/ScreenContainer';
import { Constat } from 'models/Constat';
import { useLocalStorage } from '@uidotdev/usehooks';
import { WoundedList } from '../components/Wounded';
import { ConstatUtilsService } from '../services/constat-utils.service';
import { Vehicle } from '../models/Vehicle';

export default function WoundedListScreen({
  isActive,
  setScreen,
}: {
  isActive: boolean;
  setScreen: (screen: Screen) => void;
}) {
  const { t } = useTranslation();

  const [constat] = useLocalStorage('constat', new Constat());

  const constatUtilsService = new ConstatUtilsService();

  return !isActive ? (
    <></>
  ) : (
    <ScreenContainer
      title={
        <Trans
          i18nKey={
            'screens.wounded.title.' +
            (constat.witnesses?.length ? 'withOnes' : 'empty')
          }
        >
          <span></span>
        </Trans>
      }
      extraCssClasses={['wounded-list']}
    >
      <ContentContainer>
        <p className="text text--center">
          <Trans i18nKey={'screens.wounded.text'}>
            <strong></strong>
          </Trans>
        </p>

        <WoundedList wounded={constat.wounded} />
      </ContentContainer>

      <ActionsContainer>
        <ButtonGroup>
          <Button
            variant={ButtonVariant.Green}
            isOutlined
            onClick={() => setScreen(Screen.witnesses)}
          >
            {t('common.previous')}
          </Button>

          <Button
            variant={ButtonVariant.Green}
            onClick={() =>
              setScreen(
                constatUtilsService.isVehicleComplete(
                  new Vehicle(constat.vehicleA),
                )
                  ? Screen.step1Summary
                  : !constat.vehicleA?.fleetVehicle
                    ? Screen.step1ChoiceType
                    : Screen.step1Driver,
              )
            }
          >
            {t('common.next')}
          </Button>
        </ButtonGroup>
      </ActionsContainer>
    </ScreenContainer>
  );
}
